// Mock data for izh padu sdn bhd website

export const companyInfo = {
  name: "izh padu sdn bhd",
  tagline: "Empowering Businesses with Future-Ready Technology Solutions",
  description: "We specialize in network and cybersecurity implementation, data center infrastructure solutions, firewall and switching technologies, cloud voice communication systems, and Artificial Intelligence (AI) solutions for smarter operations.",
  mission: "Our mission is to empower businesses to stay connected, secure, and future-ready through customized, scalable solutions tailored to today's digital landscape.",
  vision: "To be the leading technology partner for businesses seeking innovative, secure, and scalable infrastructure solutions in the digital era.",
  founded: "2020",
  expertise: "25+ Years Combined Experience"
};

export const services = [
  {
    id: 1,
    title: "Network Solutions",
    description: "Enterprise-grade network infrastructure design, implementation, and optimization for seamless connectivity across your organization.",
    icon: "Network",
    features: [
      "Network Architecture Design",
      "LAN/WAN Implementation",
      "Network Performance Optimization",
      "24/7 Network Monitoring"
    ]
  },
  {
    id: 2,
    title: "Security Solutions",
    description: "Comprehensive cybersecurity services to protect your business from evolving threats with advanced firewall and threat protection systems.",
    icon: "Shield",
    features: [
      "Firewall Implementation",
      "Intrusion Detection & Prevention",
      "Security Audits & Assessments",
      "Threat Intelligence & Monitoring"
    ]
  },
  {
    id: 3,
    title: "Data Center Solutions",
    description: "Scalable data center infrastructure solutions designed to ensure reliability, performance, and efficiency for your critical operations.",
    icon: "Database",
    features: [
      "Data Center Design & Build",
      "Server Infrastructure",
      "Storage Solutions",
      "Disaster Recovery Planning"
    ]
  },
  {
    id: 4,
    title: "Managed Services",
    description: "End-to-end managed IT services including cloud voice communication and AI-powered solutions for smarter business operations.",
    icon: "Settings",
    features: [
      "Cloud Voice Communication",
      "AI Solutions & Automation",
      "Proactive IT Management",
      "Help Desk & Technical Support"
    ]
  }
];

export const partners = [
  {
    id: 1,
    name: "Fortinet",
    logo: "/partners/fortinet-logo.png"
  },
  {
    id: 2,
    name: "Microsoft",
    logo: "/partners/microsoft-logo.png"
  },
  {
    id: 3,
    name: "Nextcloud",
    logo: "/partners/nextcloud-logo.png"
  },
  {
    id: 4,
    name: "VMware",
    logo: "/partners/vmware-logo.png"
  },
  {
    id: 5,
    name: "Cisco",
    logo: "/partners/cisco-logo.png"
  },
  {
    id: 6,
    name: "HPE",
    logo: "/partners/hpe-logo.png"
  },
  {
    id: 7,
    name: "TrueNAS",
    logo: "/partners/truenas-logo.webp"
  },
  {
    id: 8,
    name: "Aruba",
    logo: "/partners/aruba-logo.png"
  },
  {
    id: 9,
    name: "Ubiquiti",
    logo: "/partners/ubiquiti-logo.png"
  },
  {
    id: 10,
    name: "Extreme Networks",
    logo: "/partners/extreme-networks-logo.png"
  },
  {
    id: 11,
    name: "SonicWall",
    logo: "/partners/sonicwall-logo.png"
  },
  {
    id: 12,
    name: "Juniper Networks",
    logo: "/partners/juniper-logo.png"
  },
  {
    id: 13,
    name: "LibreNMS",
    logo: "/partners/librenms-logo.svg"
  },
  {
    id: 14,
    name: "Ubuntu",
    logo: "/partners/ubuntu-logo.png"
  },
  {
    id: 15,
    name: "H3C",
    logo: "/partners/h3c-logo.png"
  },
  {
    id: 16,
    name: "Dell",
    logo: "/partners/dell-logo.png"
  },
  {
    id: 17,
    name: "Ruijie",
    logo: "/partners/ruijie-logo.png"
  },
  {
    id: 18,
    name: "Synology",
    logo: "/partners/synology-logo.png"
  }
];

export const contactInfo = {
  email: "info@izhpadu.com",
  whatsapp: "+60192447224",
  address: "Kajang, Selangor",
  fullAddress: "20, Jalan Pinggiran Putra 5/30, Desa Pinggiran Putra, 43000 Kajang, Selangor",
  hours: "Monday - Friday: 9:00 AM - 6:00 PM",
  socialMedia: {
    linkedin: "#",
    facebook: "#",
    twitter: "#"
  }
};

export const stats = [
  {
    id: 1,
    value: "20+",
    label: "Projects Completed"
  },
  {
    id: 2,
    value: "50+",
    label: "Enterprise Clients"
  },
  {
    id: 3,
    value: "25+",
    label: "Years Experience"
  },
  {
    id: 4,
    value: "24/7",
    label: "Support Available"
  }
];
